import React from "react";
import { Card, Row, Col } from "antd";
import {
  MailOutlined,
  EyeOutlined,
  LinkOutlined,
  CheckCircleOutlined,
  CloseCircleOutlined,
  PercentageOutlined,
} from "@ant-design/icons";

const StatCard = ({ title, value, icon, color, suffix }) => (
  <Card
    className="pulse-stat-card"
    bordered={false}
    style={{
      background: `linear-gradient(135deg, ${color}15 0%, white 100%)`,
      borderRadius: "12px",
      boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
    }}
  >
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
      }}
    >
      <div>
        <div
          style={{ fontSize: "14px", color: "#8c8c8c", marginBottom: "8px" }}
        >
          {title}
        </div>
        <div style={{ fontSize: "24px", fontWeight: "bold", color: "#262626" }}>
          {value}
          {suffix && (
            <span style={{ fontSize: "16px", marginLeft: "4px" }}>
              {suffix}
            </span>
          )}
        </div>
      </div>
      <div
        style={{
          padding: "12px",
          borderRadius: "12px",
          background: color + "15",
          color: color,
        }}
      >
        {icon}
      </div>
    </div>
  </Card>
);

const StatsOverview = ({ statistics }) => {
  if (!statistics) return null;

  const stats = [
    {
      title: "Total Sent",
      value: statistics.totalSent?.toLocaleString() || 0,
      icon: <MailOutlined style={{ fontSize: "24px" }} />,
      color: "#1890ff",
    },
    {
      title: "Delivered",
      value: statistics.totalDelivered?.toLocaleString() || 0,
      icon: <CheckCircleOutlined style={{ fontSize: "24px" }} />,
      color: "#52c41a",
    },
    {
      title: "Failed",
      value: statistics.totalFailed?.toLocaleString() || 0,
      icon: <CloseCircleOutlined style={{ fontSize: "24px" }} />,
      color: "#f5222d",
    },
    {
      title: "Open Rate",
      value: statistics.openRate?.toFixed(1) || 0,
      suffix: "%",
      icon: <EyeOutlined style={{ fontSize: "24px" }} />,
      color: "#722ed1",
    },
    {
      title: "Click Rate",
      value: statistics.clickRate?.toFixed(1) || 0,
      suffix: "%",
      icon: <LinkOutlined style={{ fontSize: "24px" }} />,
      color: "#fa8c16",
    },
    {
      title: "Bounced",
      value: statistics.totalBounced?.toLocaleString() || 0,
      icon: <PercentageOutlined style={{ fontSize: "24px" }} />,
      color: "#eb2f96",
    },
  ];

  return (
    <Row gutter={[20, 20]}>
      {stats.map((stat, index) => (
        <Col xs={12} sm={8} md={8} xl={4} key={index}>
          <StatCard {...stat} />
        </Col>
      ))}
    </Row>
  );
};

export default StatsOverview;
